import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import "./Home.css";

const Home = () => {
 
  return (
      <>
      <Helmet>
          <title>Contact Us | GEMCO</title>
          <meta name="description" content="Contact Gemco for reliable MEP supply, installation, retrofit, and maintenance services across the UAE. Get in touch to discuss your project requirements." />
          <meta name="keywords" content="Contact Gemco, MEP company UAE, MEP contractor contact, Dubai MEP services, MEP project consultation, MEP engineering UAE, HVAC contractor UAE, electrical and plumbing services UAE, UAE construction support, Gemco contact details" />
      </Helmet>
    <div className="wp_contact_home_wrap">
      <div className="container wp_contact_home_content">
        <h1>Get In Touch</h1>
        <p>We would like to hear about your project.</p>
      </div>
    </div>
      </>
  );
};

export default Home;
